import { render, staticRenderFns } from "./ExercisesStudy.vue?vue&type=template&id=2678d994&scoped=true&"
import script from "./ExercisesStudy.vue?vue&type=script&lang=js&"
export * from "./ExercisesStudy.vue?vue&type=script&lang=js&"
import style0 from "./ExercisesStudy.vue?vue&type=style&index=0&id=2678d994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678d994",
  null
  
)

export default component.exports